import { Browsers, TreeStructure, Smiley, NewspaperClipping, CircleNotch } from "@phosphor-icons/react";
import { ListDropdown } from "../../ui/ListDropdown/ListDropdown";
import React, { useContext } from "react";
import { DownCarrotIcon } from "@/ui/Icons";
import { AppContext } from "@/AppContext";

export type AgentMode = "Page" | "Funnel" | "Copy" | "Research";

export const AgentModeButton = ({
  type = "Page",
  onModeChange = () => {},
}: {
  type: AgentMode;
  onModeChange: (mode: AgentMode) => void;
}) => {
  const { permissions = [] } = useContext(AppContext);
  let icon;

  if (type === "Page") icon = Browsers;
  if (type === "Funnel") icon = TreeStructure;
  if (type === "Copy") icon = Smiley;
  if (type === "Research") icon = NewspaperClipping;

  const Item = ({ icon, label, caption, isAvailable }: { icon: any, label: string, caption: string, isAvailable: boolean }) => {
    return (
      <div className={`flex gap-4 p-2 text-left ${!isAvailable && "opacity-70 cursor-not-allowed"}`}>
        <div className="mt-1">{icon && React.createElement(icon, { className: "w-4 h-4" })}</div>
        <div className="flex flex-col gap-1">
          <div className="font-bold flex items-center gap-2"><span>{label}</span>{!isAvailable && <p className="rounded-full bg-indigo-600/10 px-2.5 py-1.5 text-xs font-semibold text-indigo-600 dark:text-indigo-400">Upcoming</p>}</div>
          <div className="text-sm text-gray-500 text-left">{caption}</div>
        </div>
      </div>
    );
  };

  const items = [
    { id: "1", icon: Browsers, label: "Page Building", caption: "Create and optimize landing pages, websites, and web content", type: "Page", isAvailable: true },
    { id: "2", icon: TreeStructure, label: "Funnel Building", caption: "Build and manage marketing funnels and campaign structures", type: "Funnel", isAvailable: false },
    { id: "3", icon: Smiley, label: "Copywriting", caption: "Generate high-converting copy using proven frameworks and psychology", type: "Copy", isAvailable: false },
    { id: "4", icon: NewspaperClipping, label: "Deep Research", caption: "Conduct market research with TOC analysis and strategic insights", type: "Research", isAvailable: false },
  ];

  return (
    <ListDropdown
      items={items.map((item) => ({
        id: item.id,
        label: <Item {...item} />,
      }))}
      style={{ width: 600, left: -10, padding: 5, display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "0.5rem" }}
      element={
        <div className="flex items-center gap-2 text-sm cursor-pointer rounded-2xl p-2 px-3 dark:bg-white/10 bg-black/10 dark:text-white text-black hover:dark:bg-white/90 hover:bg-black/90 hover:dark:text-black hover:text-white">
          {icon && React.createElement(icon, { className: "w-4 h-4" })}
          {type}
          <DownCarrotIcon className="w-4 h-4" />
        </div>
      }
      onItemSelect={(item) => {
        const itm = items.find((i) => i.id === item.id);
        console.log("Item selected", itm);

        // Check for admin permission if not available
        const hasAdmin = permissions?.includes?.("admin");
        if (!itm?.isAvailable && !hasAdmin) return;

        onModeChange(itm?.type as AgentMode);
      }}
    />
  );
};